import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function AdamStory() {
    return (
        <section className="bg-white py-24 md:py-32" data-testid="adam-story">
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
                        <div className="md:col-span-1">
                            <img
                                src="https://customer-assets.emergentagent.com/job_01a94bc3-1239-473e-9729-85c2afc85aa9/artifacts/ieyndm5m_DSC_4150a%20Medium.jpg"
                                alt="Adam Cothes - Founder, White Glove Hiring"
                                className="w-full rounded-sm shadow-md object-cover"
                                data-testid="adam-headshot"
                            />
                            <div className="mt-4">
                                <p className="font-montserrat font-bold text-navy-900">Adam Cothes</p>
                                <p className="text-[#6B7280] text-sm">Founder, White Glove Hiring</p>
                            </div>
                        </div>
                        <div className="md:col-span-2">
                            <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight mb-8">
                                Built by an Operator. Tested in a Real Business.
                            </h2>
                            <div className="space-y-6 text-[#6B7280] text-lg leading-relaxed">
                                <p>
                                    Adam Cothes is a top-producing real estate agent on the Eastside Seattle market. He sells $50-60M a year, has closed almost $400M in career volume, and runs his entire operation with 3 VAs at roughly 35 hours a week.
                                </p>
                                <p>
                                    He didn't build White Glove Hiring because he saw a market opportunity. He built it because he made every mistake in the book - bad hires, no onboarding, systems that fell apart when someone left, and VAs who looked great in the interview and disappeared six weeks later.
                                </p>
                                <p>
                                    He went through the same resume roulette his clients describe. He felt the same frustration. And when he finally built a system that worked inside his own business - one with real screening, real onboarding, real oversight, and real documentation - he realized it was something other operators needed too.
                                </p>
                                <p>
                                    Every tool, every audit process, every onboarding framework inside White Glove Hiring is the same one running his real estate business today. This isn't theory. It's infrastructure that's been pressure-tested in a high-volume, high-stakes environment for over a decade.
                                </p>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
